import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Alert,
  Snackbar,
} from "@mui/material";
// components
import CommandForm from "../command-builder/CommandForm";

export default function CommandBuilderTab({ data, onSendCommand, onRedirectToOverview }) {
  const [selectedType, setSelectedType] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSendCommand = (values) => {
    try {
      if (data?.addCommand) {
        data.addCommand(values);
      } else if (onSendCommand) {
        onSendCommand(values);
      }
      setSnackbar({
        open: true,
        message: "Command sent successfully!",
        severity: "success",
      });
      setSelectedType("");
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to send command: " + error.message,
        severity: "error",
      });
    }
  };

  const handleReset = () => {
    setSelectedType("");
  };

  const handleSaveTemplate = () => {
    setSnackbar({
      open: true,
      message: "Template saved successfully!",
      severity: "success",
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Command Builder
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Build and send custom OCPI commands
          </Typography>

          <CommandForm
            selectedType={selectedType}
            onTypeChange={setSelectedType}
            formData={{}}
            onFormChange={() => {}}
            onSubmit={handleSendCommand}
            onSaveAsTemplate={handleSaveTemplate}
            onClear={handleReset}
            onRedirectToOverview={onRedirectToOverview}
          />
        </CardContent>
      </Card>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
